<app-header></app-header>

<div class="messages-container">
  <div
    *ngIf="shouldShowConnectionBanner()"
    class="connection-banner"
    [class.connecting]="connectionState === 'connecting'"
    [class.disconnected]="connectionState === 'disconnected'"
    role="alert"
    aria-live="polite"
  >
    <div class="banner-content">
      <div class="status-indicator">
        <span
          *ngIf="connectionState === 'connecting'"
          class="spinner-small"
        ></span>
        <span *ngIf="connectionState === 'disconnected'" class="warning-icon"
          >⚠️</span
        >
      </div>
      <span class="status-message">{{ getConnectionStatusText() }}</span>
      <button
        *ngIf="connectionState === 'disconnected'"
        class="reconnect-btn"
        (click)="retryConnection()"
        type="button"
        aria-label="Retry connection"
      >
        Reconnect
      </button>
    </div>
  </div>

  <div class="messages-header">
    <div class="header-content">
      <h1>Messages</h1>
      <div class="header-stats" *ngIf="hasConversations()">
        <span class="conversation-count">
          {{ conversations.length }} conversation{{
            conversations.length === 1 ? "" : "s"
          }}
        </span>
        <span
          *ngIf="getTotalUnreadCount() > 0"
          class="unread-count"
          [class]="getUnreadBadgeColor(getTotalUnreadCount())"
        >
          {{ getTotalUnreadCount() }} unread
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading conversations...</p>
  </div>

  <div *ngIf="error && !loading" class="error-container">
    <div class="error-card">
      <div class="error-icon">⚠️</div>
      <h3>Something went wrong</h3>
      <p>{{ error }}</p>
      <button class="btn-retry" (click)="retry()">
        <span class="icon">🔄</span>
        Try Again
      </button>
    </div>
  </div>

  <div
    *ngIf="!loading && !error && !hasConversations()"
    class="empty-container"
  >
    <div class="empty-card">
      <div class="empty-icon">💬</div>
      <h3>No messages yet</h3>
      <p>
        When you message sellers about their listings, your conversations will
        appear here.
      </p>
    </div>
  </div>

  <div
    *ngIf="!loading && !error && hasConversations()"
    class="conversations-list"
  >
    <div
      *ngFor="let conversation of conversations; trackBy: trackByConversation"
      class="conversation-item"
      [class.unread]="conversation.unread_count > 0"
      [class.recent-activity]="hasRecentActivity(conversation)"
      [attr.tabindex]="0"
      [attr.aria-label]="getConversationAriaLabel(conversation)"
      (click)="openConversation(conversation)"
      (keydown)="onConversationKeyDown($event, conversation)"
      role="button"
    >
      <div class="conversation-avatar">
        <div class="avatar-circle">
          {{ getOtherUserName(conversation).charAt(0).toUpperCase() }}
        </div>

        <div
          *ngIf="conversation.unread_count > 0"
          class="unread-indicator"
          [class]="getUnreadBadgeColor(conversation.unread_count)"
          [attr.aria-label]="conversation.unread_count + ' unread messages'"
        >
          {{
            conversation.unread_count > 99 ? "99+" : conversation.unread_count
          }}
        </div>

        <div
          *ngIf="isOtherUserOnline(conversation)"
          class="online-indicator"
          title="Online"
          aria-label="User is online"
        ></div>
      </div>

      <div class="conversation-content">
        <div class="conversation-header">
          <div class="user-info">
            <span class="user-name">
              {{ getOtherUserName(conversation) }}
              <span
                *ngIf="isOtherUserOnline(conversation)"
                class="online-badge"
                aria-label="Online"
              >
                • Online
              </span>
            </span>
          </div>
        </div>

        <div class="listing-info">
          <span class="listing-title">{{ getListingTitle(conversation) }}</span>
          <span class="listing-price" *ngIf="conversation.listing_price">
            {{ formatPrice(conversation.listing_price) }}
          </span>
        </div>

        <div class="last-message">
          <span
            class="message-preview"
            [class.unread-preview]="conversation.unread_count > 0"
          >
            {{ getLastMessagePreview(conversation) }}
          </span>
        </div>
      </div>

      <div class="conversation-actions">
        <button
          class="btn-delete"
          (click)="deleteConversation(conversation, $event)"
          title="Delete conversation"
          [attr.aria-label]="
            'Delete conversation with ' + getOtherUserName(conversation)
          "
          type="button"
        >
          <span class="icon">🗑️</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
